var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgVlog(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 42,
    height: 42,
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "white",
    transform: "translate(12 13)",
    d: "M17.424999 3.1968746C17.064686 2.9654379 16.616249 2.9346561 16.228748 3.112875L13 4.59375L13 4C13 2.8953123 12.104688 2 11 2L2 2C0.89531231 2 0 2.8953123 0 4L0 12C0 13.104688 0.89531231 14 2 14L11 14C12.104688 14 13 13.104688 13 12L13 11.405625L16.228125 12.885626C16.395124 12.962282 16.572813 13.000376 16.749687 13.000376C16.985031 13.000376 17.219063 12.93347 17.424376 12.801657C17.784374 12.571875 18 12.178125 18 11.721875L18 4.25C18 3.8218746 17.784374 3.4312496 17.424999 3.1968746ZM11.5 12C11.5 12.275687 11.275687 12.5 11 12.5L2 12.5C1.7243123 12.5 1.4999995 12.275687 1.4999995 12L1.4999995 4C1.4999995 3.7243128 1.7243123 3.5 2 3.5L11 3.5C11.275687 3.5 11.5 3.7243128 11.5 4L11.5 12ZM16.5 11.359375L13 9.7562504L13 6.2437501L16.5 4.6396875L16.5 11.359375Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgVlog);
export default __webpack_public_path__ + "static/media/vlog.7d8098f8579c5492fe0ffaa1f9192f49.svg";
export { ForwardRef as ReactComponent };